<template>
  <div>
    <v-container class="section_2" id="section2">
      <v-layout justify-center column>
        <h2>Em que nível de consciencia você está?</h2>
        <p style="margin-bottom: 10px; text-align: center">(inspirado no trabalho da Sra. Marian Ma Dayamayi - Marta Magalhães - Fonte: site Somos Todos Um)</p>
        <p style="margin-bottom: 50px; text-align: center">Seu nível de consciência determina seu grau de felicidade!</p>
      </v-layout>
      <v-layout wrap row style="justify-content: center">
        <v-flex>
          <iframe
            id="ytplayer"
            class="playYoutube"
            type="text/html"
            :src="`https://www.youtube.com/embed/${videoID}?version=3&autoplay=${play}&origin=http://localhost:8080`"
            frameborder="0"
            allowfullscreen
          />
        </v-flex>
        <v-flex lg9>
          <Hooper :itemsToShow="4">
            <Slide>
              <div class="list_thumb" @click="activeThumb1">
                <div class="thumb">
                  <div class="icon_hover" v-bind:class="{ active: isActive1 }">
                    <v-icon @click="activeThumb1" x-large color="white">play_arrow</v-icon>
                  </div>
                  <img src="/static/00.jpg" alt>
                </div>
              </div>
              <p class="VideoNome">Os 10 níveis da<br> consciência humana</p>
            </Slide>
            <Slide>
              <div class="list_thumb" @click="activeThumb2">
                <div class="thumb">
                  <div class="icon_hover" v-bind:class="{ active: isActive2 }">
                    <v-icon @click="activeThumb2" x-large color="white">play_arrow</v-icon>
                  </div>
                  <img src="/static/01 sobrevivencia.jpg" alt>
                </div>
              </div>
              <p class="VideoNome">Nível de consciência 1: <br> Sobrevivência?</p>
            </Slide>
            <Slide>
              <div class="list_thumb" @click="activeThumb3">
                <div class="thumb">
                  <div class="icon_hover" v-bind:class="{ active: isActive3 }">
                    <v-icon  @click="activeThumb3" x-large color="white">play_arrow</v-icon>
                  </div>
                  <img src="/static/02.jpg" alt>
                </div>
              </div>
              <p class="VideoNome">Nível de consciência 2:<br> Segurança?</p>
            </Slide>
            <Slide>
              <div class="list_thumb" @click="activeThumb4">
                <div class="thumb">
                  <div class="icon_hover" v-bind:class="{ active: isActive4 }">
                    <v-icon @click="activeThumb4" x-large color="white">play_arrow</v-icon>
                  </div>
                  <img src="/static/03.jpg" alt>
                </div>
              </div>
              <p class="VideoNome">Nível de consciência 3:<br> Sensação, prazer</p>
            </Slide>
            <Slide>
              <div class="list_thumb" @click="activeThumb5">
                <div class="thumb">
                  <div class="icon_hover" v-bind:class="{ active: isActive5 }">
                    <v-icon @click="activeThumb5" x-large color="white">play_arrow</v-icon>
                  </div>
                  <img src="/static/04.jpg" alt>
                </div>
              </div>
              <p class="VideoNome">Nível de consciência 4:<br>Domínio ou Poder Egóico</p>
            </Slide>
            <Slide>
              <div class="list_thumb" @click="activeThumb6">
                <div class="thumb">
                  <div class="icon_hover" v-bind:class="{ active: isActive5 }">
                    <v-icon @click="activeThumb5" x-large color="white">play_arrow</v-icon>
                  </div>
                  <img src="/static/05.jpg" alt>
                </div>
              </div>
              <p class="VideoNome">Nível de consciência 5: <br>A noite Escura da Alma</p>
            </Slide>
            <Slide>
              <div class="list_thumb" @click="activeThumb7">
                <div class="thumb">
                  <div class="icon_hover" v-bind:class="{ active: isActive5 }">
                    <v-icon @click="activeThumb5" x-large color="white">play_arrow</v-icon>
                  </div>
                  <img src="/static/06.jpg" alt>
                </div>
              </div>
              <p class="VideoNome">Nível de consciência 6: <br> A busca</p>
            </Slide>
            <Slide>
              <div class="list_thumb" @click="activeThumb8">
                <div class="thumb">
                  <div class="icon_hover" v-bind:class="{ active: isActive5 }">
                    <v-icon @click="activeThumb5" x-large color="white">play_arrow</v-icon>
                  </div>
                  <img src="/static/07.jpg" alt>
                </div>
              </div>
              <p class="VideoNome">Nível de consciência 7: <br> O Primeiro Despertar</p>
            </Slide>
            <Slide>
              <div class="list_thumb" @click="activeThumb9">
                <div class="thumb">
                  <div class="icon_hover" v-bind:class="{ active: isActive5 }">
                    <v-icon @click="activeThumb5" x-large color="white">play_arrow</v-icon>
                  </div>
                  <img src="/static/08.jpg" alt>
                </div>
              </div>
              <p class="VideoNome">Nível de consciência 8: <br>O Segundo Despertar...</p>
            </Slide>
            <Slide>
              <div class="list_thumb" @click="activeThumb10">
                <div class="thumb">
                  <div class="icon_hover" v-bind:class="{ active: isActive5 }">
                    <v-icon @click="activeThumb5" x-large color="white">play_arrow</v-icon>
                  </div>
                  <img src="/static/09.jpg" alt>
                </div>
              </div>
              <p class="VideoNome">Nível de consciência 9: <br> Comprometimento</p>
            </Slide>
            <Slide>
              <div class="list_thumb" @click="activeThumb11">
                <div class="thumb">
                  <div class="icon_hover" v-bind:class="{ active: isActive5 }">
                    <v-icon @click="activeThumb5" x-large color="white">play_arrow</v-icon>
                  </div>
                  <img src="/static/10.jpg" alt>
                </div>
              </div>
              <p class="VideoNome">Nível de consciência 10: <br>Iluminação</p>
            </Slide>
            <hooper-navigation slot="hooper-addons"></hooper-navigation>
          </Hooper>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container grid-list-md text-xs-center class="section_2_1">
      <v-layout row wrap align-center>
        <v-flex lg6 xs12>
          <p class="videoNome">Olhamos em volta e tendemos a almejar o lugar daquelas pessoas que alcançaram o que o mundo chama de “sucesso”. Queremos o sucesso, mas não a estrada que precisa ser percorrida até o podium. E nem nos damos conta que o grau de sucesso ou de felicidade que uma pessoa alcança está diretamente relacionado ao seu nível de consciência. A vida que você tem hoje é determinada pelo nível de consciência que você porta. Em que nível de consciência você está? A consciência pode ser aprimorada através do autoconhecimento e da autotransformação. E esta é, certamente, a mais bela e valiosa tarefa que todo ser humana pode realizar durante uma encarnação. Buscar apenas o sucessos material é ingênuo, pois que tudo que foi gerado na matéria findará no tempo. Mas o que foi forjado no Espírito, nos acompanhará por toda eternidade, durante toda Jornada de nossas Almas.</p>
        </v-flex>
        <v-flex lg6 xs12>
          <p class="citacao">"Cada ser humano é<br> uma semente da vida,<br> que busca florescer,<br> frutificar."</p><br><p class="author">Tom Vilhena</p>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import {
  Hooper,
  Slide,
  Progress as HooperProgress,
  Pagination as HooperPagination,
  Navigation as HooperNavigation
} from "hooper";
// import VuePerfectScrollbar from "vue-perfect-scrollbar";
import "hooper/dist/hooper.css";
// import Slider from "./Slider";
export default {
  name: "Section2",
  data() {
    return {
      play: 0,
      hooperSettings: {
        itemsToShow: 2,
        centerMode: true
      },
      active: [false, false, false, false],
      isActive1: false,
      isActive2: false,
      isActive3: false,
      isActive4: false,
      isActive5: false,
      videoID: "cUvisVVpbeU"
    };
  },
  components: {
    Hooper,
    Slide,
    HooperProgress,
    HooperPagination,
    HooperNavigation
    // Slider
  },
  watch: {},
  mounted () {
    this.isActive1 = true
  },
  methods: {
    card_bottom(index) {
      for (let i = 0; i < this.active.length; i++) {
        this.active[i] = false;
      }
      this.active[index] = 1;
    },
    activeThumb1() {
      this.isActive1 = true;
      this.isActive2 = false;
      this.isActive3 = false;
      this.isActive4 = false;
      this.isActive5 = false;
      this.isActive6 = false;
      this.isActive7 = false;
      this.isActive8 = false;
      this.isActive9 = false;
      this.isActive10 = false;
      this.isActive11 = false;
      this.videoID = 'cUvisVVpbeU'
      this.play = 1
    },
    activeThumb2() {
      this.isActive1 = false;
      this.isActive2 = true;
      this.isActive3 = false;
      this.isActive4 = false;
      this.isActive5 = false;
      this.isActive6 = false;
      this.isActive7 = false;
      this.isActive8 = false;
      this.isActive9 = false;
      this.isActive10 = false;
      this.isActive11 = false;
      this.videoID = 'SC04kJeZtSo'
    },
    activeThumb3() {
      this.isActive1 = false;
      this.isActive2 = false;
      this.isActive3 = true;
      this.isActive4 = false;
      this.isActive5 = false;
      this.isActive6 = false;
      this.isActive7 = false;
      this.isActive8 = false;
      this.isActive9 = false;
      this.isActive10 = false;
      this.isActive11 = false;
      this.videoID = 'z28zjR5p0Eo'
    },
    activeThumb4() {
      this.isActive1 = false;
      this.isActive2 = false;
      this.isActive3 = false;
      this.isActive4 = true;
      this.isActive5 = false;
      this.isActive6 = false;
      this.isActive7 = false;
      this.isActive8 = false;
      this.isActive9 = false;
      this.isActive10 = false;
      this.isActive11 = false;
      this.videoID = 'HMjnQfOYj20'
    },
    activeThumb5() {
      this.isActive1 = false;
      this.isActive2 = false;
      this.isActive3 = false;
      this.isActive4 = false;
      this.isActive5 = true;
      this.isActive6 = false;
      this.isActive7 = false;
      this.isActive8 = false;
      this.isActive9 = false;
      this.isActive10 = false;
      this.isActive11 = false;
      this.videoID = 'yTFycH9P41Y'
    },
    activeThumb6() {
      this.isActive1 = false;
      this.isActive2 = false;
      this.isActive3 = false;
      this.isActive4 = false;
      this.isActive5 = false;
      this.isActive6 = true;
      this.isActive7 = false;
      this.isActive8 = false;
      this.isActive9 = false;
      this.isActive10 = false;
      this.isActive11 = false;
      this.videoID = 'PEff8IoLONY'
    },
    activeThumb7() {
      this.isActive1 = false;
      this.isActive2 = false;
      this.isActive3 = false;
      this.isActive4 = false;
      this.isActive5 = false;
      this.isActive6 = false;
      this.isActive7 = true;
      this.isActive8 = false;
      this.isActive9 = false;
      this.isActive10 = false;
      this.isActive11 = false;
      this.videoID = 'nz36WwOJTYI'
    },
    activeThumb8() {
      this.isActive1 = false;
      this.isActive2 = false;
      this.isActive3 = false;
      this.isActive4 = false;
      this.isActive5 = false;
      this.isActive6 = false;
      this.isActive7 = false;
      this.isActive8 = true;
      this.isActive9 = false;
      this.isActive10 = false;
      this.isActive11 = false;
      this.videoID = 'bYhRvpHMmv8'
    },
    activeThumb9() {
      this.isActive1 = false;
      this.isActive2 = false;
      this.isActive3 = false;
      this.isActive4 = false;
      this.isActive5 = false;
      this.isActive6 = false;
      this.isActive7 = false;
      this.isActive8 = false;
      this.isActive9 = true;
      this.isActive10 = false;
      this.isActive11 = false;      
      this.videoID = 'ct2Ad7T-RXg'
    },
    activeThumb10() {
      this.isActive1 = false;
      this.isActive2 = false;
      this.isActive3 = false;
      this.isActive4 = false;
      this.isActive5 = false;
      this.isActive6 = false;
      this.isActive7 = false;
      this.isActive8 = false;
      this.isActive9 = false;
      this.isActive10 = true;
      this.isActive11 = false;
      this.videoID = 'uPphZRgGmTA'
    },
    activeThumb11() {
      this.isActive1 = false;
      this.isActive2 = false;
      this.isActive3 = false;
      this.isActive4 = false;
      this.isActive5 = false;
      this.isActive6 = false;
      this.isActive7 = false;
      this.isActive8 = false;
      this.isActive9 = false;
      this.isActive10 = false;
      this.isActive11 = true;
      this.videoID = 'f9yvGW4C0_s'
    }
  }
};
</script>
<style scoped lang="stylus">
i = !important;
h2
  font-family 'Montserrat', sans-serif
  font-size 2rem
  font-weight 700
p
  font-family 'Montserrat', sans-serif
  font-size 1rem
  font-weight 400
  width auto
  text-align left

.citacao
  font-family 'Montserrat', sans-serif
  color #313131
  font-size 2rem
  text-align: center
  font-weight 700

.author
  font-family 'Montserrat', sans-serif
  font-size 1.5rem
  color "#313131"
  text-align center
  font-weight 400

.section_2 {
  padding: 60px;
}
.active {
  opacity 1
  background-color  rgba(54, 41, 46, 0.3)
  border-bottom solid 3px red
}

.scroll-area {
  position: relative;
  margin: auto;
  width: 400px;
  height: 405px;
  background: black;
  border-radius: 5px;
}

.playYoutube {
  width: 720px;
  height: 405px;
}

.description {
  text-align: left;
}

.card {
  width: 94%;
  margin: 5px;
  background: black;
  color: white;
  border-bottom: 1px solid #f4f4f4;

  &:hover {
    background: #303030;
  }
}


.thumb
  width: 160px;
  height: 80px;
  margin-bottom: 5px;
  display flex
  cursor: pointer;
  justify-content center
  &:hover
    z-index 105
    background-color  rgba(54, 41, 46, 0.3)
  img
    height: 80px;
    width 160px i
    z-index -1;

.hooper {
  height: 120px;
  width: 720px;
  margin: 0 auto;
}

.hooper-slide {
  width: auto i;
  height: auto i;
  margin: 0 5px;
}

.VideoNome
  text-align left
  font-family 'Montserrat'
  font-weight 600
  font-size .9rem

@media (max-width: 560px)
  .section_2
    padding 40px 0
  .section_2_1
    padding 0px 10px
  h2
    margin 50px 0 40px 0 i
  .playYoutube
    width: 100%;
    height: 205px;

  .hooper
    height: 120px;
    width: 100%;
    margin: 0 auto;

  p
    width 100%
    text-align: center
  .scroll-area
    position: relative;
    margin: auto;
    width: auto;
    height: 405px;
    background: black;
    border-radius: 5px;
  .citacao
    margin-top: 20px
@media (min-width: 560.1px) and (max-width: 768px)
  .playYoutube
    width: 100%;
  .hooper
    height: 120px;
    width: 100%;
    margin: 0 auto;
  p
    width 100%
    text-align: center
  .citacao
    margin-top: 20px
</style>



// WEBPACK FOOTER //
// src/components/Section2.vue